import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiTrash2, FiEdit2, FiCheck, FiX } from 'react-icons/fi';
import { getRelativeTime, updateHistoryName } from '../utils/history';
import './HistoryCard.css';

const HistoryCard = ({ item, onDelete }) => {
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [editName, setEditName] = useState(item.name);

  const handleCardClick = (e) => {
    // Don't navigate if clicking on buttons or input
    if (e.target.closest('.card-actions') || e.target.closest('.name-input')) {
      return;
    }
    navigate(`/results/${item.id}`);
  };

  const handleSaveName = () => {
    if (editName.trim()) {
      updateHistoryName(item.id, editName.trim());
      setIsEditing(false);
    }
  };

  const handleCancelEdit = () => {
    setEditName(item.name);
    setIsEditing(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSaveName();
    } else if (e.key === 'Escape') {
      handleCancelEdit();
    }
  };

  const preview = item.brief?.substring(0, 60) + (item.brief?.length > 60 ? '...' : '');

  return (
    <motion.div
      className="history-card"
      onClick={handleCardClick}
      whileHover={{ y: -4 }}
      transition={{ duration: 0.2 }}
    >
      <div className="card-header">
        <span className="card-emoji">🐿️</span>
        <div className="card-actions">
          {isEditing ? (
            <>
              <button
                className="action-icon save"
                onClick={handleSaveName}
                aria-label="Save name"
              >
                <FiCheck />
              </button>
              <button
                className="action-icon cancel"
                onClick={handleCancelEdit}
                aria-label="Cancel editing"
              >
                <FiX />
              </button>
            </>
          ) : (
            <>
              <button
                className="action-icon edit"
                onClick={() => setIsEditing(true)}
                aria-label="Edit name"
              >
                <FiEdit2 />
              </button>
              <button
                className="action-icon delete"
                onClick={() => onDelete(item.id)}
                aria-label="Delete ramble"
              >
                <FiTrash2 />
              </button>
            </>
          )}
        </div>
      </div>

      {isEditing ? (
        <input
          type="text"
          className="name-input"
          value={editName}
          onChange={(e) => setEditName(e.target.value)}
          onKeyDown={handleKeyDown}
          autoFocus
          onClick={(e) => e.stopPropagation()}
        />
      ) : (
        <h3 className="card-name">{item.name}</h3>
      )}

      <p className="card-preview">{preview}</p>

      <span className="card-time">{getRelativeTime(item.timestamp)}</span>
    </motion.div>
  );
};

export default HistoryCard;
